import React, { useEffect, useState } from 'react';
import { MessageSquare, Send, ChevronRight } from 'lucide-react';
import { messagesApi } from '../../lib/api';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';

export default function Messages() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ subject: '', message: '' });
  const [sending, setSending] = useState(false);

  const refresh = () => {
    messagesApi.list().then(setItems).catch(() => setItems([])).finally(() => setLoading(false));
  };
  useEffect(refresh, []);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await messagesApi.create({ ...form, source: 'support' });
      setForm({ subject: '', message: '' });
      refresh();
    } finally { setSending(false); }
  };

  return (
    <div>
      <div className="mb-6">
        <span className="eyebrow">Messages</span>
        <h1 className="mt-2 text-3xl font-bold text-[#0b1f3a]">Messages</h1>
        <p className="text-slate-600 text-sm mt-1">Conversations with our team about your policies and quotes.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white border border-slate-200 rounded-2xl p-6">
          <h2 className="font-semibold text-[#0b1f3a] mb-4">Send a new message</h2>
          <form onSubmit={submit} className="space-y-3">
            <div>
              <Label className="field-label">Subject</Label>
              <Input required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
            </div>
            <div>
              <Label className="field-label">Message</Label>
              <Textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
            </div>
            <button type="submit" disabled={sending} className="btn-primary disabled:opacity-60">
              <Send size={16} /> {sending ? 'Sending...' : 'Send message'}
            </button>
          </form>
        </div>

        <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
          <div className="p-5 border-b border-slate-100">
            <h2 className="font-semibold text-[#0b1f3a]">Inbox</h2>
          </div>
          {loading ? (
            <p className="p-8 text-center text-slate-500 text-sm">Loading...</p>
          ) : items.length === 0 ? (
            <div className="p-10 text-center">
              <MessageSquare size={28} className="mx-auto text-slate-300" />
              <p className="mt-2 text-slate-500 text-sm">No messages yet.</p>
            </div>
          ) : (
            <ul className="divide-y divide-slate-100">
              {items.map((m) => (
                <li key={m.id} className="p-4 flex items-center gap-3">
                  <span className="icon-tile !w-9 !h-9"><MessageSquare size={14} /></span>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-sm text-[#0b1f3a] truncate">{m.subject}</p>
                    <p className="text-xs text-slate-500 truncate">{m.message}</p>
                    <p className="text-[11px] text-slate-400 mt-0.5">{new Date(m.created_at).toLocaleString()}</p>
                  </div>
                  <span className={`text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full ${
                    m.status === 'new' ? 'bg-amber-100 text-amber-700' :
                    m.status === 'replied' ? 'bg-emerald-100 text-emerald-700' :
                    'bg-slate-100 text-slate-600'
                  }`}>{m.status}</span>
                  <ChevronRight size={14} className="text-slate-300" />
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
